<sia-base-pdf-viewer
  [file]="file"
  [initialZoom]="initialZoom"
  (matchesCountChange)="matchesCountChange.emit($event)"
></sia-base-pdf-viewer>
